module.exports = __webpack_public_path__ + "img/ios-share.994e9676.svg";